"use client";
import React from "react";
import { cn } from "~/utils/fontsConfig";

const RiverLoading = ({ className = "", height = 50, width = 15 }) => {
    return (
        <div
            className={cn(
                "absolute inset-0 left-1/2 top-1/2 flex h-fit w-fit -translate-x-1/2 items-center justify-center gap-1 bg-transparent bg-opacity-50",
                className,
            )}
        >
            {[0, 1, 2].map((index) => (
                <svg
                    key={index}
                    viewBox="198.6959 143.646 15.9451 48.879"
                    width={width}
                    height={height}
                    className="transition-transform duration-1000 ease-in-out"
                    style={{
                        animation: `pulse 1.8s ease-in-out ${
                            index * 0.3
                        }s infinite`,
                    }}
                >
                    <path
                        d="M 206.268 192.525 L 206.268 169.562 C 206.268 169.562 206.65 167.266 210.208 165.515 C 212.233 164.531 213.383 163.275 213.984 162.344 C 214.422 161.69 214.641 160.978 214.641 160.268 L 214.641 143.646 L 206.924 143.646 L 206.924 164.531 C 206.924 164.531 207.143 166.554 202.657 168.796 C 198.169 171.039 198.717 175.03 198.717 175.03 L 198.717 192.47 L 206.268 192.47 L 206.268 192.525 Z"
                        fill="white"
                    >
                        <animate
                            attributeName="fill"
                            values="white;#47AA56;#47AA56;white"
                            dur="1.8s"
                            repeatCount="indefinite"
                            begin={index === 0 ? "0s" : "0.3s"}
                        />
                    </path>
                </svg>
            ))}
            <style jsx>{`
                @keyframes pulse {
                    0%,
                    100% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.2);
                    }
                }
            `}</style>
        </div>
    );
};

export const SmallRiverLoading = ({
    className = "",
    height = 30,
    width = 10,
}) => {
    return (
        <div
            className={cn(
                "flex h-fit w-full items-center justify-center gap-1",
                className,
            )}
        >
            {[0, 1, 2].map((index) => (
                <svg
                    key={index}
                    viewBox="198.6959 143.646 15.9451 48.879"
                    width={width}
                    height={height}
                    className="transition-transform duration-1000 ease-in-out"
                    style={{
                        animation: `pulse 1.8s ease-in-out ${
                            index * 0.3
                        }s infinite`,
                    }}
                >
                    <path
                        d="M 206.268 192.525 L 206.268 169.562 C 206.268 169.562 206.65 167.266 210.208 165.515 C 212.233 164.531 213.383 163.275 213.984 162.344 C 214.422 161.69 214.641 160.978 214.641 160.268 L 214.641 143.646 L 206.924 143.646 L 206.924 164.531 C 206.924 164.531 207.143 166.554 202.657 168.796 C 198.169 171.039 198.717 175.03 198.717 175.03 L 198.717 192.47 L 206.268 192.47 L 206.268 192.525 Z"
                        fill="white"
                    >
                        <animate
                            attributeName="fill"
                            values="white;#47AA56;#47AA56;white"
                            dur="1.8s"
                            repeatCount="indefinite"
                            begin={index === 0 ? "0s" : "0.3s"}
                        />
                    </path>
                </svg>
            ))}
        </div>
    );
};

export default RiverLoading;
